export const BATCH_REPORTS_INTERVAL_SECS = 5;
export const MAX_BATCH = 25;
